import React from "react";
import { useSelector } from "react-redux";

import type { AppState } from "src/store";

import type { ReportParameters } from "./report";
import ProfitLossReport from "./ProfitLossReport";
import ProfitLossComparisonReport from "./ProfitLossComparisonReport";
import SalesTaxReport from "./SalesTaxReport";
import {
  profitLossReportSelector,
  profitLossComparisonReportSelector,
  salesTaxReportSelector,
} from "./selectors";

/**
 * Nested views so Content can render live reports without calling hooks
 * conditionally — each wrapper always runs its selector with frozen run params.
 */

export function LiveProfitLossReportView({
  parameters,
}: {
  parameters: ReportParameters;
}) {
  const report = useSelector((state: AppState) =>
    profitLossReportSelector(state, parameters)
  );
  return <ProfitLossReport report={report} />;
}

export function LiveProfitLossComparisonReportView({
  parameters,
  onGroupByChange,
}: {
  parameters: ReportParameters;
  onGroupByChange: (groupBy: "month" | "quarter") => void;
}) {
  const report = useSelector((state: AppState) =>
    profitLossComparisonReportSelector(state, parameters)
  );
  return (
    <ProfitLossComparisonReport
      report={report}
      onGroupByChange={onGroupByChange}
    />
  );
}

export function LiveSalesTaxReportView({
  parameters,
}: {
  parameters: ReportParameters;
}) {
  const report = useSelector((state: AppState) =>
    salesTaxReportSelector(state, parameters)
  );
  return <SalesTaxReport report={report} />;
}
